import { create } from 'zustand';
import { AccountApi, AccountEntity, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface IAccountsByCustomerStore {
  loading: boolean;
  error: string | null;
  account: AccountEntity | null;
  accounts: AccountEntity[];
  getAccountsByCustomer: (request: { customerId: string; accountId?: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAccountsByCustomerStore = create<IAccountsByCustomerStore>((set) => ({
  loading: false,
  error: null,
  account: null,
  accounts: [],

  getAccountsByCustomer: ApiUtils.wrapperApi(async (request: { customerId: string; accountId?: string }, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null, accounts: [], account: null });
      const result = await AccountApi.getAccountsByCustomer(request.customerId, signal);
      const account = result.find((account) => account.accId.toString() === request.accountId);
      set({ accounts: result ?? [], account: account ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ accounts: [], account: null, loading: false, error: null }),
}));
